import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

type PaginationProps = {
	prev: string | null
	next: string | null
	onClick: (data: any) => void
}

const buttonClassName =
	'inline-flex h-8 items-center gap-1.5 rounded-md border border-border bg-background px-3 shadow text-[12px] font-medium text-foreground transition-colors hover:bg-muted [&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:stroke-2'

export const Pagination = ({ prev, next, onClick }: PaginationProps) => {
	const { t } = useTranslation()

	return (
		<div className="flex items-center gap-2">
			{prev ? (
				<button type="button" className={buttonClassName} onClick={() => onClick(prev)}>
					<ChevronLeftIcon />
					<span>{t('Prev')}</span>
				</button>
			) : null}
			{next ? (
				<button type="button" className={buttonClassName} onClick={() => onClick(next)}>
					<span>{t('Next')}</span>
					<ChevronRightIcon />
				</button>
			) : null}
		</div>
	)
}
